import { useContext } from "react";
import { AnimationDriverContext } from "../contexts/AnimationDriverContext";
import { getAnimationDriver } from "../helpers/getAnimationDriver";
import { isRSC } from "@tamagui/constants";
const useAnimationDriver = () => {
  if (isRSC)
    return getAnimationDriver();
  return useContext(AnimationDriverContext) ?? getAnimationDriver();
};
export {
  useAnimationDriver
};
//# sourceMappingURL=useAnimationDriver.js.map
